import { Pipe, PipeTransform } from '@angular/core';
import { ClassificationService } from 'core/classification.service';

@Pipe({ name: 'classification' })
export class ClassificationPipe implements PipeTransform {
  cachedId: string;
  cachedValue: string;

  constructor(private service: ClassificationService) { }

  transform(valueId: string): any {
    if (valueId === null || valueId === undefined || valueId === '' || valueId === '00000000-0000-0000-0000-000000000000') {
      return '';
    }
    if (valueId !== this.cachedId) {
      this.service.getClassificationValueNameByValueId(valueId).subscribe(x => {
        this.cachedValue = x;
      });
    }
    
    return this.cachedValue;
  }
}
